// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__GmZBl","footer":"Form_footer__3N90M"};